//
import { VCard } from "vuetify/lib"

//
export default {
    name: "module-layout",
    components: {
        VCard,
    }
}